import React, { FC } from 'react';
import Button from '../../Components/Button/Button';
import ProductCard from '../../Components/ProductCard/ProductCard';
import styles from './PastOrders.module.scss';

const description = () => (
  <>
    <div className={styles.descriptionTitle}>Faux Leather Jacket</div>
    <div className={styles.price}>&#8377;1200</div>
    <div className={styles.date}>2 September 2020</div>
  </>
);

const PastOrders: FC = () => (
  <div className={styles.cartPageContainer}>
    <div className={styles.title}>Past Orders</div>
    <>
      <div>
        <div key={13}>
          <ProductCard
            id={15}
            imageUrl={`${process.env.REACT_APP_BASE_URL}/img/81fPKd-2AYL._AC_SL1500_.jpg`}
            description={description()}
            tailing={(
              <div className={styles.orderButton}>
                <Button>Order Again</Button>
              </div>
            )}
            shadow={false}
          />
        </div>
      </div>
    </>
  </div>
);

export default PastOrders;
